import Api from "../../Api";
import { modifyError } from "../../Validation/ModifyErrros";

export const createMenubar = async (data) => {
  try {
    let res = await Api.post("/menubar", data);
    return res?.data;
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const getMenubarData = async (query) => {
  try {
    let res = await Api.get("/menubar", { params: query });
    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const getMenubarDataById = async (id) => {
  try {
    let res = await Api.get("/menubar/" + id);
    return res?.data;
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const updateMenubar = async (id, data) => {
  try {
    let res = await Api.patch("/menubar/" + id, data);
    return res?.data;
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const deleteMenubarData = async (id) => {
  try {
    let res = await Api.delete("/menubar/" + id);
    return res?.data;
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const getMenubarLocationAndId = async (url) => {
  try {
    let res = await Api.get("/menubar/location", { params: { url } });
    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const updateMenubarPosition = async (items) => {
  try {
    let res = await Api.patch("/menubar/relocate-position", items);
    return res?.data;
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const createMenubarSubmenu = async (menubarId, data) => {
  try {
    let res = await Api.post(`/menubar/${menubarId}/submenu`, data);
    return res?.data;
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const getMenubarSubmenu = async (menubarId) => {
  try {
    let res = await Api.get(`/menubar/${menubarId}/submenu`);
    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const getMenubarSubmenuById = async (menubarId, id) => {
  try {
    let res = await Api.get(`/menubar/${menubarId}/submenu/${id}`);
    return res?.data;
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const updateMenubarSubmenu = async (menubarId, id, data) => {
  try {
    let res = await Api.patch(`/menubar/${menubarId}/submenu/${id}`, data);
    return res?.data;
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const deleteMenubarSubmenu = async (menubarId, id) => {
  try {
    let res = await Api.delete(`/menubar/${menubarId}/submenu/${id}`);
    return res?.data;
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const getMenubarSubmenuLocationAndId = async (url) => {
  try {
    let res = await Api.get("/menubar/submenu/location", { params: { url } });
    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const updateMenubarSubmenuPosition = async (menubarId, items) => {
  try {
    let res = await Api.patch(
      `/menubar/${menubarId}/submenu/relocate-position`,
      items
    );
    return res?.data;
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};
